import React from 'react';
import UserAvatar from 'components/pure/utils/UserAvatar';
import withCoachingPlanWizard from 'components/coaching/wizard/withCoachingPlanWizard';
import ArrowForwardIcon from 'material-ui/svg-icons/navigation/arrow-forward';

class SuggestedAction extends React.PureComponent {
  render() {
    const {className, recommendation, sessionUser, user} = this.props;
    return (
      <div
        className={className}
        key={`${user.id} ${recommendation}`}
        onClick={() =>
          this.props.onCreatePlan({
            coach: sessionUser,
            rep: user,
            skillName: recommendation,
          })
        }>
        <UserAvatar className="user-avatar" user={user} />
        <div className="action-label">
          Coach {user.getDisplayName()} on <b>{recommendation}</b>
        </div>
        <div className="action-arrow">
          <ArrowForwardIcon className="svg-arrow" />
        </div>
      </div>
    );
  }
}

export default withCoachingPlanWizard(SuggestedAction);
